import { HttpContextToken } from '@angular/common/http';

export const ContextKey = {
  ApiVersion: new HttpContextToken<string>(() => '1.0'),
  ApiEncryption: new HttpContextToken<boolean>(() => true),
};
